export class TourneeMouvementEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        millesime: { key: 'millesime', optional: true, default: '' },
        cahier: { key: 'cahier', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        numeroLotOperateur: { key: 'numeroLotOperateur', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        numeroExpertise: { key: 'numeroExpertise', optional: true },
        passage: { key: 'passage', optional: true, default: '' },
        cepage: { key: 'cepage', optional: true },
        volume: { key: 'volume', optional: true, default: '' },
        type: { key: 'type', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' },
        contenant: { key: 'contenant', optional: true, default: '' },
        date: { key: 'date', optional: true, default: '' },
        dateRetiraison: { key: 'dateRetiraison', optional: true, default: '' },
        typeConditionnement: { key: 'typeConditionnement', optional: true, default: '' },
        degre: { key: 'degre', optional: true, default: '' },
        couleur: { key: 'couleur', optional: true, default: '' },
        numeroEchantillon: { key: 'numeroEchantillon', optional: true, default: '' },
        procedure: { key: 'procedure', optional: true, default: '' },
        typeControle: { key: 'typeControle', optional: true, default: '' }
    };

    id: number;
    millesime: string;
    cahier: string;
    produit: string;
    numeroLot: string;
    numeroLotOperateur: string;
    numeroDossier: string;
    numeroExpertise: number;
    passage: string;
    cepage: number;
    volume: string;
    type: string;
    logement: string;
    contenant: string;
    date: string;
    dateRetiraison: string;
    typeConditionnement: string;
    degre: string;
    couleur: string;
    numeroEchantillon: string;
    procedure: string;
    typeControle: string;
}
